import { ProgressBarData } from "../ProgressBarData";
import { IBranchDetails } from "../branch-details/branch-details";
import { DealerProductsType } from "../common";
import { MarketingProspectsConsents, QuestionInfo } from "../common/question-info";
import { CustomerInfo } from "../customer/customer-info";
import { DeviceInfo } from "../device/device-info";
import { PolicyResponse } from "../device/policy-response";
import { SelectedProduct } from "../product/product";
import { SaleSteps } from "./sale-steps";

export class BaseSaleActivity {
  public SalesId: string;
  public CustomerInfo: CustomerInfo;
  public PaymentMethodInfo: any;
  public PolicyNumber: string;
  
}

export class SalesActivity {
  public SalesId: string;
  public IMEI: string;
  public SerialNumber: string;
  public BranchCode: string;
  public BranchName: string;
  public DeviceInfo: DeviceInfo;
  public DemandsAndNeedsQuestions: QuestionInfo[];
  public Product: SelectedProduct;
  public CustomerInfo: CustomerInfo;
  public QuestionAnswer:QuestionInfo[];
  public PaymentMethodInfo: any;
  public PolicyResponse: PolicyResponse;
  public SignaturePackageId: string;
  public PolicyDocuments: FormData[];
  public PolicyNumber: string;
  public PaymentReferenceNumber: string;
  public PaymentInstrumentType: string;
  public PaymentType: string;
  public CurrencyCode: string;
  public CompanyCode: string;
  public IsPolicyTypeGadget: boolean;
  public IsPolicyTypeSericeOffer: boolean;
  DealerCode: string;
  CertificateDate: string;
  GuaranteeEffectiveDate:string;
  CertificateDuration: string;
  CoverageStartOffset: string;
  SalesPrice: string;
  CustomerDataConsent: boolean;
  CustomerConsentCommunication: boolean;
  MarketingProspectsConsent: boolean;
  MarketingProspectsConsentsCollection?: MarketingProspectsConsents[];
  MarketingTAndCCollections?: MarketingProspectsConsents[];
  LastSavedSection: SaleSteps;
  ProgressBarData: ProgressBarData;
  SubmittedDate: string;
  DealerShipProgramType: string;
  Email: string;
  IsPaymentGateway: boolean;
  BranchDetails: IBranchDetails
  SalesInsuranceType?: DealerProductsType;
}

